export default __webpack_public_path__ + "static/media/empty-plate.3eb3d939.png";